import { style } from 'typestyle';
import {
    COLOR_01,
    COLOR_05,
    COLOR_08,
    COLOR_12,
    FONT_WEIGHT_BLACK,
    FONT_WEIGHT_BOLD,
    FONT_WEIGHT_REGULAR,
    MARGINS_PX
} from '../../../constants';
import { mixinFont } from '../../../style.mixin';
import { desktopStyles, tabletStyles } from '../../../utils';

const contentHeightPx: number = 560;

export const countryProfileClassName = style({
    padding: `${MARGINS_PX}px 0`
});

export const countryProfileNoResultsTitleClassName = style({
    ...mixinFont(32, FONT_WEIGHT_BLACK, 34, COLOR_05)
});

export const countryProfileNoResultsMessageClassName = style({
    ...mixinFont(20, FONT_WEIGHT_BLACK),
    textAlign: 'center',
    padding: `${MARGINS_PX * 4}px 0`,
});

export const countryProfileFiltersCellClassName = style();

export const countryProfileFilterCountriesClassName = style({
    height: '180px',
    width: '100%'
}, tabletStyles({
    height: contentHeightPx + 'px',
    width: '240px'
}));

export const countryProfileDataWrapperClassName = style({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    height: '100%',
    width: '100%'
});

export const countryProfileDataHeaderClassName = style({
    flexShrink: 0,
    flexGrow: 0
});

export const countryProfileContentCellClassName = style({
});

export const countryProfileCountryNameClassName = style({
    ...mixinFont(32, FONT_WEIGHT_BOLD, undefined, COLOR_05)
});

export const countryProfileRegionNameClassName = style({
    ...mixinFont(16, FONT_WEIGHT_BOLD, undefined, COLOR_05)
});

export const countryProfileActiveListItemClassName = style({
    color: COLOR_01
});

export const countryProfilePageSmallTextClassName = style({
    display: 'block',
    opacity: .5,
    padding: `0 ${MARGINS_PX}px ${MARGINS_PX}px`,
    maxWidth: '270px',
    boxSizing: 'border-box',
    ...mixinFont(12, FONT_WEIGHT_REGULAR, 15, COLOR_12)
});

export const womenInLocalGovernmentTextClassName = style(
    {
        display: 'block',
        textAlign: 'center',
        ...mixinFont(14, FONT_WEIGHT_REGULAR, 16, COLOR_08)
    },
    tabletStyles({
        textAlign: 'left',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'left'
    }),
    desktopStyles({
        textAlign: 'center',
        justifyContent: 'center'
    })
);

export const womenInLocalGovernmentTextInnerClassName = style({
    whiteSpace: 'nowrap',

    $nest: {
        'a': {
            color: COLOR_08,
            textDecoration: 'none',
            fontWeight: FONT_WEIGHT_BOLD,

            $nest: {
                '&:hover': {
                    textDecoration: 'none'
                }
            }
        }
    },
});

export const womenInLocalGovernmentLogoClassName = style(
    {
        display: 'block',
        position: 'relative',

        $nest: {
            'img': {
                display: 'block',
                width: '100%',
                maxWidth: '124px',
                border: 0,
                margin: '0 auto',
                padding: 0
            }
        }
    },
    tabletStyles({
        $nest: {
            '&:before, &:after': {
                content: '""',
                display: 'block',
                clear: 'both'
            },
            'img': {
                margin: 0,
                float: 'right'
            }
        }
    })
);
